<template>
  <div>
    <b-modal
      v-model="modalShown"
      size="sm"
      title="Asignar Area"
      hide-footer="true"
    >
      <b-form @submit.prevent="submit">
        <b-form-group>
          <label class="font-weight-bold" for="name">Seleccione Area</label>
          <b-form-select
            v-model="selected"
            :options="Areas"
            value-field="id"
            text-field="name"
            required
          ></b-form-select>
        </b-form-group>
        <div class="w-100">
          <b-button
            variant="primary"
            type="submit"
            :disabled="submitActive"
            class="float-right ml-1"
          >
            <b-spinner v-if="loading" class="float-right" small></b-spinner
            >Guardar
          </b-button>
          <!-- <b-button class="float-right ml-1" variant="primary">Guardar</b-button> -->
          <b-button class="float-right ml-1" @click="modalShown = !modalShown"
            >Cancelar</b-button
          >
        </div>
      </b-form>
    </b-modal>
  </div>
</template>
<script>
import {
  integer,
  required,
  minValue,
  maxValue
} from "vuelidate/lib/validators";

import { bus } from "../../main";

export default {
  name: "assingAreaModal",
  props: {
    Areas: {
      type: Array,
      default: []
    },
    markedRows: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      modalShown: false,
      selected: null,
      submitActive: false,
      loading: false
    };
  },
  methods: {
    focusMyElement() {
      this.$refs.focusThis.focus();
    },
    async submit() {
      const thisV = this;

      const data = {
        contents_select: thisV.markedRows,
        area_select: thisV.selected
      };

      thisV.submitActive = true;
      thisV.loading = true;

      try {
        const response = await thisV.$axios({
          method: "POST",
          url: "/bagno/content/assign_area_content/",
          data: data
        });

        thisV.modalShown = false;
        //thisV.resetForm();

        thisV.$toast.success("Operación realizada con éxito", "");
        bus.$emit("refreshStockListProcess");
        thisV.loading = false;
        thisV.submitActive = false;
      } catch (error) {
        thisV.modalShown = false;
        thisV.resetForm();
        thisV.$toast.error("Problemas al realizar la operación", "");
        thisV.loading = false;
        thisV.submitActive = false;
      }
    },
    inputSoloNumero(event) {
      event.target.value = event.target.value.replace(/[^0-9]/, "");
    }
  },
  validations: {
    label_quantity: {
      minValue: minValue(0),
      maxValue: maxValue(4),
      required,
      integer
    }
  }
};
</script>

<style scoped></style>
